import React from "react";
import { IndicatorLoader, percentDiff } from "./DashboardUtils";
var KPIBox = function (_a) {
    var label = _a.label, value = _a.value, previous = _a.previous, _b = _a.prefix, prefix = _b === void 0 ? "" : _b, _c = _a.decimals, decimals = _c === void 0 ? 0 : _c;
    var diff = percentDiff(value !== null && value !== void 0 ? value : null, previous !== null && previous !== void 0 ? previous : null);
    return (React.createElement("div", { className: "bg-gray-900/80 rounded-lg p-3 text-center" },
        React.createElement("div", { className: "text-xs text-gray-400" }, label),
        React.createElement("div", { className: "text-2xl font-bold" }, value == null ? (React.createElement(IndicatorLoader, null)) : (React.createElement(React.Fragment, null,
            prefix,
            typeof value === "number"
                ? value.toLocaleString("pt-BR", {
                    minimumFractionDigits: decimals,
                    maximumFractionDigits: decimals,
                })
                : "??",
            typeof previous === "number" && diff !== null && (React.createElement("div", { className: "mt-1 flex items-center justify-center text-sm font-semibold ".concat(diff >= 0 ? "text-green-400" : "text-red-400") },
                React.createElement("svg", { className: "h-4 w-4 mr-1 inline ".concat(diff >= 0 ? "" : "rotate-180"), fill: "none", stroke: "currentColor", strokeWidth: "2", viewBox: "0 0 24 24" },
                    React.createElement("path", { strokeLinecap: "round", strokeLinejoin: "round", d: "M5 10l7-7m0 0l7 7m-7-7v18" })),
                Math.abs(diff).toFixed(1),
                "%")))))));
};
export default KPIBox;
